<template>
   <div class="d-flex justify-content-center m-t-32">
      <div class="col-md-12 col-lg-6">
         <div class="css_pageTitle2 m-b-16">Редактор Рубрики:</div>
         <div class="form-control mb-3">
            <label class="form-label">Название рубрики</label>
            <input
                    v-model="editableRubric.name.value"
                    @blur="editableRubric.name.blur"
                    :class="{'is-invalid': !editableRubric.name.valid && editableRubric.name.touched}"
                    type="text" class="form-control"
            >
            <div
                    v-if="editableRubric.name.touched && editableRubric.name.errors.required"
                    class="form-text"
            >Обязательное поле</div>
            <div
                    v-if="editableRubric.name.touched && editableRubric.name.errors.exist"
                    class="form-text"
            >Такое название уже существует</div>
         </div>
         <div class="form-control mb-3">
            <label class="form-label">Название файла</label>
            <input
                    v-model="editableRubric.image_link.value"
                    @blur="editableRubric.image_link.blur"
                    :class="{'is-invalid': !editableRubric.image_link.valid && editableRubric.image_link.touched}"
                    type="text" class="form-control"
            >
            <div
                    v-if="editableRubric.image_link.touched && editableRubric.image_link.errors.required"
                    class="form-text"
            >Обязательное поле</div>
         </div>
         <div class="d-flex justify-content-between">
            <button @click="saveEditRubric" class="btn btn-success">Сохранить</button>
            <button @click="closeEditRubric" class="btn btn-secondary">Отмена</button>
         </div>
      </div>
   </div>
</template>

<script>
import { computed, reactive, watch } from "vue";
import {useField, validatorsList} from "../helpers/validateField";
import {storeToRefs} from "pinia";
import {useRubricArticleStore} from "../../../stores/store";
import {getRubricById} from "../../../shared/services/util";
import {AddOrUpdateRubricById, prepareSaveRubricAJ} from "../services/util";

export default {
   props: {
      usedRubric: { type: Object, required: true }
   },
   emits: ['save-edit-rubric', 'close-edit-rubric'],
   setup(props, { emit }) {

      const rubricArticleStore = useRubricArticleStore();
      const { rubrics } = storeToRefs(rubricArticleStore);

      const {required, exist} = validatorsList();

      const editableRubric = reactive({
         id: props.usedRubric.id,
         name: useField({
            value: props.usedRubric.name,
            validators: {required, exist: exist(rubrics.value, props.usedRubric.id, 'name')}
         }),
         image_link: useField({
            value: props.usedRubric.image_link,
            validators: {required}
         }),
         enabled: computed(() => {
            const rubricObj = getRubricById(rubrics.value, editableRubric.id)
            let enabled = 0;

            if(rubricObj != null) {
               enabled = rubricObj.enabled;
            }

            return enabled;
         }),
         valid: computed(() => {
            let valid = true;

            if(!editableRubric.name.valid) {
               valid = false;
            }

            if(!editableRubric.image_link.valid) {
               valid = false;
            }

            return valid;
         })
      });

      watch(
         () => props.usedRubric,
         (oldValue, newValue) => {

            editableRubric.id = newValue.id;
            editableRubric.name.value = newValue.name;
            editableRubric.name.touched = false;
            editableRubric.image_link.value = newValue.image_link;
            editableRubric.image_link.touched = false;
         },
         {
            deep: true
         }
      )

      const saveEditRubric = () => {
         if(!editableRubric.valid) {
            if(!editableRubric.name.valid) {
               editableRubric.name.touched = true;
            }

            if(!editableRubric.image_link.valid) {
               editableRubric.image_link.touched = true;
            }

            return;
         }

         const {id, name, image_link, enabled} = editableRubric;

         const newRubricObj = {
            id,
            name: name.value,
            image_link: image_link.value,
            enabled
         };

         prepareSaveRubricAJ(newRubricObj).then((r) => {
            AddOrUpdateRubricById(rubrics, newRubricObj, newRubricObj.id, r.id)

            emit("save-edit-rubric")
         });
      }

      const closeEditRubric = () => {
         emit("close-edit-rubric")
      }


      return {
         editableRubric,
         saveEditRubric,
         closeEditRubric
      }
   }
}
</script>

<style scoped>

</style>